/* eslint-disable no-console */
import moment from 'moment';

import {months} from '../../../constants/Common';
import {financialYear as IFYear} from '../../../interface/Units';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import {MYData} from '../Interface/common';

const yearIndex = (
  fromYear: string,
  toYear: string,
  index: number,
  FY: IFYear
) => {
  const isSame = fromYear === toYear;
  switch (FY) {
    case IFYear.AprMar:
      return isSame ? fromYear : index >= 9 ? toYear : fromYear;
    case IFYear.JanDec:
      return fromYear;
    case IFYear.JulJun:
      return isSame ? fromYear : index >= 6 ? toYear : fromYear;
    case IFYear.OctSep:
      return isSame ? fromYear : index >= 3 ? toYear : fromYear;
    default:
      return isSame ? fromYear : index >= 9 ? toYear : fromYear;
  }
};

const addFromAndTo = (data: any, fromYear: string, toYear: string): any => {
  const {financialYear} = useCompanyStore.getState().preUnits;

  const updatedTimeFrame = data?.timeFrameData.map((item: MYData) => {
    const dataExist = item?.data?.some((item) => {
      return item.value;
    });
    let timeFrameData: any[];
    let filteredData: any[];
    if (dataExist) {
      if (item.timeFrame === 'yearly') {
        filteredData = item.data.slice(0, 1);
      } else {
        filteredData = item.data;
      }
      timeFrameData = filteredData?.map((dataItem, index) => {
        const {value} = dataItem;

        const FYMonths = months?.[financialYear];

        const month = FYMonths[index];

        const year = yearIndex(fromYear, toYear, index, financialYear);

        return {
          value: value ?? null,
          fromDate:
            item.timeFrame === 'monthly'
              ? moment(`1/${month}/${year}`).startOf('month').format()
              : moment(`1/${FYMonths[0]}/${fromYear}`).format(),
          toDate:
            item.timeFrame === 'monthly'
              ? moment(`1/${month}/${year}`).endOf('month').format()
              : moment(`1/${FYMonths[11]}/${toYear}`).endOf('month').format()
        };
      });
    } else {
      timeFrameData = [];
    }

    return {
      ...item,
      data: timeFrameData
    };
  });

  data.timeFrameData = updatedTimeFrame;

  return data;
};

export default addFromAndTo;
